import { render, staticRenderFns } from "./touchpoint.vue?vue&type=template&id=444872fc"
import script from "./touchpoint.vue?vue&type=script&lang=js"
export * from "./touchpoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports